// @flow
import PrimaryPalette from '../../colors';
import Tokens from '../../tokens';

const Theme = {
  default: {
    closeIconColor: PrimaryPalette.mediumEvergreen,
  },
  informational: {
    backgroundColor: Tokens.colors.hover,
    iconColor: PrimaryPalette.mediumIris,
  },
  warning: {
    backgroundColor: PrimaryPalette.extraLightYellow,
    iconColor: PrimaryPalette.darkYellow,
  },
};

export default Theme;
